import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { City } from './city.model';

export const loadCitys = createAction(
    '[City/API] Load Citys',
    props<{ citys: City[] }>()
);

export const addCity = createAction(
    '[City/API] Add City',
    props<{ city: City }>()
);

export const upsertCity = createAction(
    '[City/API] Upsert City',
    props<{ city: City }>()
);

export const addCitys = createAction(
    '[City/API] Add Citys',
    props<{ citys: City[] }>()
);

export const upsertCitys = createAction(
    '[City/API] Upsert Citys',
    props<{ citys: City[] }>()
);

export const updateCity = createAction(
    '[City/API] Update City',
    props<{ city: Update<City> }>()
);

export const updateCitys = createAction(
    '[City/API] Update Citys',
    props<{ citys: Update<City>[] }>()
);

export const deleteCity = createAction(
    '[City/API] Delete City',
    props<{ id: string }>()
);

export const deleteCitys = createAction(
    '[City/API] Delete Citys',
    props<{ ids: string[] }>()
);

export const clearCitys = createAction('[City/API] Clear Citys');

export const getCitys = createAction(
    '[City/API] Get Citys',
    props<{ State?: string; ZipCode?: string }>()
);

export const emptyAction = createAction('[City/API] empty');
